import { render } from "./MarkenBoxenServicePartner.vue?vue&type=template&id=54340679"
import script from "./MarkenBoxenServicePartner.vue?vue&type=script&lang=ts"
export * from "./MarkenBoxenServicePartner.vue?vue&type=script&lang=ts"

import "./MarkenBoxenServicePartner.vue?vue&type=style&index=0&id=54340679&lang=scss"
script.render = render

export default script